import React, { useEffect, useRef, useState } from "react";
import { FaQuestionCircle } from "react-icons/fa";

/**
 * Soru işareti + tıklayınca açılan küçük açıklama kutusu.
 *
 * Kutu `absolute` konumlanır — açılınca çevredeki bileşenleri itmez, kart
 * yüksekliği/grid değişmez. Dışarı tıklama ve Escape kapatır. Hover yerine
 * tıklama: dokunmatik ekranda da çalışsın.
 *
 * @param {React.ReactNode} children  kutunun içeriği
 * @param {"left"|"right"} align      kutunun ikona göre hizası (sağ kenardaki
 *                                    ikonlarda "right" — kutu dışarı taşmasın)
 * @param {string} label              ekran okuyucu etiketi
 */
export default function InfoTip({ children, align = "left", label = "Açıklama" }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onPointerDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    const onKeyDown = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onPointerDown);
    document.addEventListener("touchstart", onPointerDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("mousedown", onPointerDown);
      document.removeEventListener("touchstart", onPointerDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [open]);

  return (
    <span ref={ref} className="relative inline-flex">
      <button
        type="button"
        aria-label={label}
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        className={`inline-flex items-center justify-center rounded-full transition-colors ${
          open ? "text-indigo-600" : "text-gray-400 hover:text-gray-600"
        }`}
      >
        <FaQuestionCircle className="w-3.5 h-3.5" />
      </button>
      {open && (
        <span
          role="tooltip"
          className={`absolute z-40 top-full mt-1.5 w-60 max-w-[70vw] rounded-lg border border-gray-200 bg-white p-2.5 text-xs leading-relaxed text-gray-600 shadow-lg ${
            align === "right" ? "right-0" : "left-0"
          }`}
        >
          {children}
        </span>
      )}
    </span>
  );
}
